var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteInv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_86_2793",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_86_2793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.0752 20.5002C6.6416 20.5002 6.2708 20.346 5.9628 20.0376C5.6544 19.7292 5.5002 19.3584 5.5002 18.9252V5.62498H4.5V4.37518H8.85V3.62518H15.15V4.37518H19.5V5.62498H18.4998V18.9252C18.4998 19.3584 18.3456 19.7292 18.0372 20.0376C17.7292 20.346 17.3584 20.5002 16.9248 20.5002H7.0752ZM17.2248 5.62498H6.7752V18.9252C6.7752 19.0084 6.8044 19.0834 6.8628 19.1502C6.9208 19.2166 6.9916 19.2498 7.0752 19.2498H16.9248C17.0084 19.2498 17.0792 19.2166 17.1372 19.1502C17.1956 19.0834 17.2248 19.0084 17.2248 18.9252V5.62498ZM9.4998 17.175H10.7502V7.69978H9.4998V17.175ZM13.2498 17.175H14.5002V7.69978H13.2498V17.175ZM6.7752 5.62498V19.2498V18.9252V5.62498Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteInv);
export default __webpack_public_path__ + "static/media/delete_inv.2be7ba3035a442cbced1345202e36db8.svg";
export { ForwardRef as ReactComponent };